module.exports = __webpack_public_path__ + "static/male02-f42d5c3a390fd0e367e2c6e84e0d01a0.png";